// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bfccfb14","453":"c5eaf93b","455":"799fcc2d","762":"e8e4033b","889":"fe196d26","938":"fca46b29","977":"2a3e216c"}[chunkId] + ".chunk.js";
};